import { useRef, useState } from 'react';
// @mui
import { Stack, InputBase, InputBaseProps, IconButton, InputAdornment } from '@mui/material';
// utils
import uuidv4 from '../../../../utils/uuidv4';
// auth
import { useUserContext } from '../../../../auth/useUserContext';
// @types
import { IChatSendMessage } from '../../../../@types/chat';
// components
import Iconify from '../../../../components/iconify';

// ----------------------------------------------------------------------

interface Props extends InputBaseProps {
  conversationId: string | null;
  onSend: (data: IChatSendMessage) => void;
}

export default function ChatMessageInput({
  disabled,
  conversationId,
  onSend,
  sx,
  ...other
}: Props) {
  const { data: userData } = useUserContext();
  const CURRENT_USER_ID = userData?.id || '';

  const [message, setMessage] = useState('');

  const handleSend = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSendMessage();
    }
  };

  const handleSendMessage = () => {
    if (onSend && message && conversationId) {
      onSend({
        conversationId,
        messageId: uuidv4(),
        message,
        contentType: 'text',
        attachments: [],
        createdAt: new Date(),
        senderId: CURRENT_USER_ID,
      });
      setMessage('');
    }
  };

  return (
    <>
      <InputBase
        value={message}
        onKeyUp={handleSend}
        onChange={(event) => setMessage(event.target.value)}
        placeholder="Type a message"
        endAdornment={
          <Stack direction="row" spacing={1} sx={{ flexShrink: 0, mr: 1.5 }}>

            <IconButton 
              disabled={disabled || !message.trim()} 
              size="small" 
              onClick={handleSendMessage}
              color="primary"
            >
              <Iconify icon="eva:paper-plane-fill" />
            </IconButton>
          </Stack>
        }
        sx={{
          pl: 1,
          height: 56,
          flexShrink: 0,
          borderTop: (theme) => `solid 1px ${theme.palette.divider}`,
          ...sx,
        }}
        {...other}
      />
    </>
  );
}
